module.exports = __webpack_public_path__ + "src/assets/images/icon-wind_speed.svg?f8a09ccdcc8fcc8da923fd4b5cc939ab";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-wind_speed.svg
// module id = 576
// module chunks = 0